import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
  Card,
  Form,
} from "react-bootstrap";

import { appConfig } from "../../config";
import "./Orders.css";
import { jsPDF } from "jspdf";
import ItemDetailsEdit from "./ItemDetailsEdit";
import ReactPaginate from "react-paginate";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
var dateFormat = require("dateformat");

class OrdersView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {
        avlblQntty: null,
      },
      qty: 0,
      avlble: null,
      itempage: 0,
      itemsperPage: 5,
      showurgtconfirmModal: false,
      showurgtrejectModal: false,
      showpaymntconfirmModal: false,
      searchitems: "",
      searchShow: false,
      count: 0,
      shwGetOrderConfirmModal: false,
    };
    this.handleRadio = this.handleRadio.bind(this);
  }

  newitemChange = (ev) => {
    let name = ev.target.name;
    let val = ev.target.value;
    if (name === "srchitem") {
      this.setState(
        {
          ...this.state,
          searchShow: true,
          searchitems: val,
        },
        () => {
          this.props.fetchChemistitems({
            searchKey: this.state.searchitems,

            data: this.props.ordersToShow,
          });
        },
      );
    }
  };

  itemsPageClick = (ev) => {
    const selecteditemPage = ev.selected;
    this.props.OrdersViewpageSelected({
      item: this.props.ordersToShow,
      page: selecteditemPage + 1,
    });
    this.setState({ itempage: selecteditemPage });
  };

  resetitemPage = () => {
    this.setState({
      ...this.state,
      itempage: 0,
    });
  };

  showUrhntRrjectModal = () => {
    this.setState({
      ...this.state,
      showurgtrejectModal: true,
    });
  };

  handleClose = () => {
    this.setState({
      ...this.state,
      showurgtrejectModal: false,
    });
  };

  showUrhntConfirmModal = () => {
    this.setState({
      ...this.state,
      showurgtconfirmModal: true,
    });
  };

  ConfirmhandleClose = () => {
    this.setState({
      ...this.state,
      showurgtconfirmModal: false,
    });
  };

  createPdf = () => {
    let value = this.props.ordersToShow;
    this.props.pdfOrderFullData(value);
  };

  handleEditItemDetails = (item) => {
    this.setState({
      showItemDetailsEditModel: true,
      ItemDetailsdtList: item,
    });
  };

  closeEditModel = () => {
    this.setState({
      showItemDetailsEditModel: false,
    });
  };

  handleRadio(event, index) {
    if (!this.state.searchShow) {
      this.props.chemistOrderDtls[index].avlble = event.target.value;
      this.props.chemistOrderDtls[index].avlble =
        event.currentTarget.value === "true" ? true : false;

      this.setState({ avlble: event.avlble });
    } else {
      this.props.chemistOrderSearchList[index].avlble = event.target.value;
      this.props.chemistOrderSearchList[index].avlble =
        event.currentTarget.value === "true" ? true : false;
      this.setState({ avlble: event.avlble });
    }
  }

  add = (index, item) => {
    this.setState({ qty: item.avlblQntty });

    this.props.chemistOrderDtls[index].avlblQntty += 1;
  };

  decrement = (index, item) => {
    this.setState({ qty: item.avlblQntty });

    if (this.props.chemistOrderDtls[index].avlblQntty - 1 < 1) {
    } else {
      this.props.chemistOrderDtls[index].avlblQntty -= 1;
    }
  };

  handleChange = (e, index, maxQty) => {
    let value = e.target.value;

    if (value === "") {
      value = "";
    } else {
      value = Number(value);
      if (isNaN(value) || value > maxQty) return;
    }

    if (!this.state.searchShow) {
      if (!this.props.chemistOrderDtls) return;
      this.props.chemistOrderDtls[index].avlblQntty = value;
    } else {
      if (!this.props.chemistOrderSearchList) return;
      this.props.chemistOrderSearchList[index].avlblQntty = value;
    }

    this.setState({});
  };

  Submit = () => {
    const data =
      this.props.ordersToShow && this.props.ordersToShow.item
        ? this.props.ordersToShow.item
        : null;
    const createdByRoleKey =
      data && data.createdBy
        ? (data.createdBy.role || "").toLowerCase()
        : "";
    const shouldShowConfirmButton =
      createdByRoleKey === "employee" || createdByRoleKey === "distributor";
    const submitStatus = shouldShowConfirmButton ? "accepted" : "confirm";

    if (!this.state.searchShow) {
      let value = this.props.chemistOrderDtls;

      let edit = false;
      {
        value.forEach((item) => {
          if (item.avlble === true) {
            edit = edit || true;
          } else {
            edit = edit || false;
          }
        });
      }

      if (edit === true) {
        this.setState({ value: this.props.chemistOrderDtls.id });
        this.props.EditItemDetails({ items: value, status: submitStatus });
        this.props.close();

        this.setState({
          showurgtconfirmModal: false,
        });
      } else {
        toast.error(
          "Sorry, you cannot accept this orde since no items are available now",
          {
            autoClose: 3000,
          },
        );

        this.setState({
          showurgtconfirmModal: false,
        });
      }
    } else {
      this.setState({ value: this.props.chemistOrderSearchList.id });
      let value = this.props.chemistOrderSearchList;
      this.props.EditItemDetails({ items: value, status: submitStatus });
      this.props.close();

      this.setState({
        showurgtconfirmModal: false,
      });
    }
  };

  reject = () => {
    let value = this.props.ordersToShow;
    this.props.ordersInActive(value);
    this.props.close();
    this.props.resetPage();

    this.setState({
      showurgtrejectModal: false,
    });
  };

  changetoPaid = (item) => {
    this.setState({
      showpaymntconfirmModal: true,
      paymentStatus: item,
    });
  };

  closepaymntconfirmModal = () => {
    this.setState({
      showpaymntconfirmModal: false,
    });
  };

  statusisPaid = () => {
    let value = this.state.paymentStatus;
    this.props.changePaymentstatus(value);
    this.props.close();

    this.closepaymntconfirmModal();
  };

  showGetOrderConfirmModal = () => {
    this.setState({
      shwGetOrderConfirmModal: true,
    });
  };

  closeGetOrderConfirmModal = () => {
    this.setState({
      shwGetOrderConfirmModal: false,
    });
  };

  handleGetOrder = () => {
    const data =
      this.props.ordersToShow && this.props.ordersToShow.item
        ? this.props.ordersToShow.item
        : null;
    this.props.UrgentordersDelivered({ item: data });
    this.props.close();
    this.closeGetOrderConfirmModal();
  };

  render() {
    const data =
      this.props.ordersToShow && this.props.ordersToShow.item
        ? this.props.ordersToShow.item
        : null;

    const createdByRoleKey =
      data && data.createdBy
        ? (data.createdBy.role || "").toLowerCase()
        : "";
    const shouldShowConfirmButton =
      createdByRoleKey === "employee" || createdByRoleKey === "distributor";
    const acceptActionLabel = shouldShowConfirmButton ? "Confirm" : "Accept";

    const {
      showurgtrejectModal,
      showurgtconfirmModal,
      itempage,
      itemsperPage,
    } = this.state;
    const {
      showUrhntRrjectModal,
      handleClose,
      reject,
      showUrhntConfirmModal,
      ConfirmhandleClose,
      Submit,
      itemsPageClick,
    } = this;


    function capitalizeWord(word) {
      if (!word) return "";
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    const startIndex = itempage * itemsperPage;
    const endIndex = startIndex + itemsperPage;

    const paginatedItems = this.props.chemistOrderDtls
      ? this.props.chemistOrderDtls.slice(startIndex, endIndex)
      : [];

    const items = this.props.chemistOrderDtls
      ? this.props.chemistOrderDtls
      : null;

    const ordercount =
      this.props.chemistOrderDtlsCount && this.props.chemistOrderDtlsCount;

    let p1 = itempage + 1;

    const safeOrderCount = Number(ordercount) || 0;
    const itemPageCount = Math.ceil(safeOrderCount / itemsperPage);

    const SearchCount =
      this.props.chemistOrderSearchCount && this.props.chemistOrderSearchCount;

    return (
      <div>
        <div className="modelboxdesigns">
          <Modal
            show={this.props.show}
            onHide={this.props.close}
            animation={false}
            size="lg"
            backdrop="static"
            className="Modalmodelboxdesigns"
          >
            <Modal.Header
              style={{
                fontSize: "35px",
                backgroundColor: "#1768B7",
                color: "white",
              }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Urgent Order Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body id="check">
              <Row>
                <Col lg={6} md={6} sm={12} xs={12}>
                  <div className="chemistdetails">
                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Name : </span>{" "}
                      {data !== null && data.orderFrom
                        ? data.orderFrom.name + " " + data.orderFrom.lName
                        : null}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Mobile : </span>{" "}
                      {data !== null &&
                        data.orderFrom !== null &&
                        data.orderFrom
                        ? data.orderFrom.mobileNo
                        : null}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Email : </span>
                      {data !== null &&
                        data.chmstDtls !== null &&
                        data.chmstDtls
                        ? data.chmstDtls.email
                        : "Nill"}
                    </p>
                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Address : </span>{" "}
                      {data !== null && data.addr},{" "}
                      {data !== null && data.pincode}
                    </p>
                  </div>
                </Col>

                <Col lg={6} md={6} sm={12} xs={12}>
                  <div className="chemistDtls">
                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Order No : </span>{" "}
                      {data !== null && data.orderNo}
                    </p>
                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Pharmacy : </span>{" "}
                      {data !== null && data.orderFromName}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> City : </span>{" "}
                      {data !== null && data.city}
                    </p>
                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead">
                        {" "}
                        Created Date :{" "}
                      </span>
                      {data !== null && data.createdAt
                        ? dateFormat(data.createdAt, "dd-mmm-yyyy, h:MM TT")
                        : null}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead"> Created By : </span>{" "}
                      {data !== null && data.createdBy ? `${data.createdBy.fullName} (${data.createdBy.designation || capitalizeWord(data.createdBy.role)})` : "Nill"}
                    </p>
                  </div>
                </Col>
              </Row>

              {data !== null &&
                (data.status === "shipmentReady" ||
                  data.status === "delivered") &&
                data.invDtls !== null &&
                data.invDtls.status === "open" && (
                  <Row className="viewRow">
                    <br />
                    <br />
                    <br />
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <p class="modelStatus">
                        Payment Status :{" "}
                        <span style={{ textTransform: "uppercase" }}>
                          {data !== null && data.invDtls && data.invDtls.status}
                        </span>
                        <br />
                        <span>
                          Amount : INR{" "}
                          {data !== null && data.invDtls && data.invDtls.amount}
                        </span>
                        <br />
                        <span>
                          Remarks:{" "}
                          {data !== null && data.prcpNotes
                            ? data.prcpNotes
                            : "No additional notes"}
                        </span>
                      </p>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6} className="chemistDtls">
                      <Button
                        className="queryBtn"
                        onClick={() => this.changetoPaid({ item: data })}
                      >
                        Order Paid?
                      </Button>
                    </Col>
                  </Row>
                )}

              {data !== null &&
                (data.status === "shipmentReady" ||
                  data.status === "delivered") &&
                data.invDtls !== null &&
                data.invDtls.status === "paid" && (
                  <Row>
                    <br />
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <p
                        style={{
                          marginLeft: "20px",
                          color: "rgb(204, 32, 38)",
                          fontWeight: "bold",
                        }}
                      >
                        Payment Status :{" "}
                        <span style={{ textTransform: "uppercase" }}>
                          {data !== null && data.invDtls && data.invDtls.status}
                        </span>
                        <br />
                        <span>
                          Amount : INR{" "}
                          {data !== null && data.invDtls && data.invDtls.amount}
                        </span>
                        <br />
                        <span>
                          Remarks:{" "}
                          {data !== null && data.prcpNotes
                            ? data.prcpNotes
                            : "No additional notes"}
                        </span>
                      </p>
                    </Col>
                  </Row>
                )}

              {data !== null &&
                data.status !== "shipmentReady" &&
                data.status !== "delivered" && (
                  <Row>
                    <br />
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <p
                        style={{
                          marginLeft: "20px",
                          color: "rgb(204, 32, 38)",
                          fontWeight: "bold",
                        }}
                      >
                        Remarks:{" "}
                        {data !== null && data.prcpNotes
                          ? data.prcpNotes
                          : "No additional notes"}
                      </p>
                    </Col>
                  </Row>
                )}

              <div className="coomonlinebody">
                <hr />
              </div>

              <Row>
                <Col xs={12} sm={12} md={3} lg={3}>
                  <h3 className="itemdetailshd">Item Details</h3>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4}>
                  {data !== null && data.status === "created" ? (
                    <div className="commonInputdiv">
                      <div className="commonInput">
                        <i className="fa fa-search fa-lg cmnSearchIcon" />
                        <input
                          type="text"
                          name="srchitem"
                          autoComplete="off"
                          placeholder="Item Name"
                          value={this.state.searchitems}
                          onChange={this.newitemChange}
                        />
                      </div>
                    </div>
                  ) : null}
                </Col>

                <Col xs={12} sm={12} md={2} lg={2} />
                <Col xs={12} sm={12} md={3} lg={3}>
                  <div style={{ paddingLeft: "20px" }}>
                    <span className="cmnPageCount">
                      {ordercount === undefined && SearchCount === undefined ? (
                        0
                      ) : (
                        <span>
                          {!this.state.searchShow && ordercount}
                          {this.state.searchShow && SearchCount}
                        </span>
                      )}
                    </span>
                    <span className="cmnResutText">Items</span>
                  </div>
                </Col>
              </Row>
              {data !== null && data.status === "shipmentReady" ? (
                <div>
                  <p className="messagetext">
                    Waiting for item receipt from chemist{" "}
                  </p>
                </div>
              ) : null}

              {data !== null && data.status === "delivered" ? (
                <div>
                  <p className="messagetext">Delivered Completed</p>
                </div>
              ) : null}

              {data !== null &&
                data.hasCreated &&
                data.status === "accepted" ? (
                <div>
                  <p className="messagetext">Dispatched items</p>
                </div>
              ) : null}

              <div>
                {data !== null && data.hasCreated ? null : data !== null &&
                  data.status === "confirm" ? (
                  <p className="messagetext">
                    Waiting for chemist confirmation
                  </p>
                ) : data !== null && data.status === "created" ? null : data !==
                  null && data.status === "cancelled" ? null : data !==
                    null && data.status === "rejected" ? null : (
                  <div>
                    <p className="messagetext">Upload Invoice</p>
                  </div>
                )}
              </div>

              <Card.Body>
                <div className="viewnormaltablecommon">
                  {!this.state.searchShow && (
                    <Table className="dashTable">
                      <thead className="tablecommonclr">
                        <tr>
                          <th>#</th>
                          <th>Item Code</th>
                          <th>Item Name</th>
                          <th style={{ width: "20%" }}>Order Quantity</th>
                          <th style={{ width: "20%" }}>Available Quantity</th>
                          {data && data.status === "rejected" ? (
                            ""
                          ) : (
                            <th>Availability</th>
                          )}
                        </tr>
                      </thead>

                      <tbody className="tablecommonclrtbody tableBody">
                        {this.props.chemistOrderDtls &&
                          paginatedItems.map(
                            (item, i) => (
                              (this.state.qty = item.avlblQntty),
                              (
                                <tr key={i}>
                                  <th scope="row">{startIndex + i + 1}</th>
                                  <td className="cmn_Cap">
                                    {item !== null &&
                                      item.itemCode !== null &&
                                      item.itemCode !== undefined &&
                                      item.itemCode.drugCode}
                                  </td>
                                  <td className="cmn_Cap">
                                    {item !== null && item.itemName}
                                  </td>
                                  <td className="cmn_Cap">
                                    {item !== null && item.qntty}
                                  </td>
                                  <td className="cmn_Cap">
                                    {data !== null &&
                                      data.status === "created" ? (
                                      <div className="radiobtnclass">
                                        <input
                                          type="text"
                                          className="textBox form-control"
                                          name="avlblQntty"
                                          autoComplete="off"
                                          value={this.state.qty}
                                          onChange={(e) =>
                                            this.handleChange(e, i, item.qntty)
                                          }
                                        />
                                      </div>
                                    ) : (
                                      <div>
                                        {item !== null && item.avlblQntty}
                                      </div>
                                    )}
                                  </td>
                                  {data !== null &&
                                    data.status === "created" ? (
                                    <td className="cmn_Cap">
                                      <div className="radiobtnclass">
                                        <label>
                                          <input
                                            type="radio"
                                            value="true"
                                            defaultChecked
                                            checked={item.avlble === true}
                                            onChange={(e) =>
                                              this.handleRadio(e, i)
                                            }
                                          />
                                          Yes
                                        </label>

                                        <label>
                                          <input
                                            type="radio"
                                            value="false"
                                            checked={item.avlble === false}
                                            onChange={(e) =>
                                              this.handleRadio(e, i)
                                            }
                                          />
                                          No
                                        </label>
                                      </div>
                                    </td>
                                  ) : data !== null &&
                                    data.status === "rejected" ? (
                                    ""
                                  ) : (
                                    <td className="cmn_Cap">
                                      <div>
                                        {item !== null && item.avlble == true
                                          ? "Available"
                                          : "Not Available"}
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              )
                            ),
                          )}
                      </tbody>
                    </Table>
                  )}

                  {this.state.searchShow && (
                    <Table className="dashTable">
                      <thead className="tablecommonclr">
                        <tr>
                          <th>#</th>
                          <th>Item Code</th>
                          <th>Item Name</th>
                          <th style={{ width: "20%" }}>Quantity</th>
                          {data && data.status === "rejected" ? (
                            ""
                          ) : (
                            <th>Availability</th>
                          )}
                        </tr>
                      </thead>

                      <tbody className="tablecommonclrtbody tableBody">
                        {this.props.chemistOrderSearchList &&
                          this.props.chemistOrderSearchList.map((item, i) => (
                            <tr key={i}>
                              <th scope="row">{i + 1}</th>
                              <td className="cmn_Cap">
                                {item !== null &&
                                  item.itemCode !== null &&
                                  item.itemCode !== undefined &&
                                  item.itemCode.drugCode}
                              </td>
                              <td className="cmn_Cap">
                                {item !== null && item.itemName}
                              </td>
                              <td className="cmn_Cap">
                                {data !== null && data.status === "created" ? (
                                  <div className="radiobtnclass">
                                    <input
                                      type="number"
                                      className="textBox form-control"
                                      min={0}
                                      max={item.qntty}
                                      value={item.avlblQntty}
                                      onChange={(e) =>
                                        this.handleChange(e, i, item.qntty)
                                      }
                                    />
                                  </div>
                                ) : (
                                  <div>{item !== null && item.avlblQntty}</div>
                                )}
                              </td>

                              {data !== null && data.status === "created" ? (
                                <td className="cmn_Cap">
                                  <div className="radiobtnclass">
                                    <label>
                                      <input
                                        type="radio"
                                        value="true"
                                        defaultChecked
                                        checked={item.avlble === true}
                                        onChange={(e) => this.handleRadio(e, i)}
                                      />
                                      Yes
                                    </label>

                                    <label>
                                      <input
                                        type="radio"
                                        value="false"
                                        checked={item.avlble === false}
                                        onChange={(e) => this.handleRadio(e, i)}
                                      />
                                      No
                                    </label>
                                  </div>
                                </td>
                              ) : data !== null &&
                                data.status === "rejected" ? (
                                ""
                              ) : (
                                <td className="cmn_Cap">
                                  <div>
                                    {item !== null && item.avlble == true
                                      ? "Available"
                                      : "Not Available"}
                                  </div>
                                </td>
                              )}
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  )}

                  {!this.state.searchShow &&
                    (this.props.chemistOrderDtls === undefined ||
                      (this.props.chemistOrderDtls &&
                        this.props.chemistOrderDtls.length === 0)) && (
                      <div>
                        <div className="noDataImgDiv">
                          <Image
                            className="noDataImg"
                            src={require("../../assets/img/nodata4.png")}
                          />
                        </div>
                        <div className="noDataTextDiv">No Items Found</div>
                      </div>
                    )}

                  {this.state.searchShow &&
                    (this.props.chemistOrderSearchList === undefined ||
                      (this.props.chemistOrderSearchList &&
                        this.props.chemistOrderSearchList.length === 0)) && (
                      <div>
                        <div className="noDataImgDiv">
                          <Image
                            className="noDataImg"
                            src={require("../../assets/img/nodata4.png")}
                          />
                        </div>
                        <div className="noDataTextDiv">No Items Found</div>
                      </div>
                    )}
                </div>
              </Card.Body>

              {safeOrderCount > itemsperPage && (
                <div className="paginationDiv">
                  <ReactPaginate
                    forcePage={itempage}
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={itemPageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={itemsPageClick}
                    containerClassName={"pagination flex-wrap"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                  />
                </div>
              )}
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#1768B7" }}>
              {data !== null && data.status === "created" ? (
                <div>
                  <Button className="queryBtn" onClick={this.createPdf}>
                    Download as PDF
                  </Button>
                  <Button
                    className="queryBtn"
                    onClick={this.showUrhntRrjectModal}
                  >
                    Reject
                  </Button>
                  <Button
                    className="queryBtnaccept"
                    onClick={this.showUrhntConfirmModal}
                  >
                    {acceptActionLabel}
                  </Button>
                </div>
              ) : null}
              {data !== null &&
                data.status === "shipmentReady" &&
                data.createdBy &&
                (createdByRoleKey === "employee" ||
                  createdByRoleKey === "distributor") && (
                  <div>
                    <Button
                      className="queryBtnaccept"
                      onClick={this.showGetOrderConfirmModal}
                    >
                      Get Order
                    </Button>
                  </div>
                )}
            </Modal.Footer>
          </Modal>
        </div>

        <Modal
          show={showurgtrejectModal}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          centered={true}
          className="modelalertbox"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.24)" }}
        >
          <Modal.Body>
            <div>
              <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                <b> Reject Order?</b>
              </h6>
            </div>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="danger"
                  className="cmnDelCnclBtn"
                  onClick={handleClose}
                >
                  No
                </Button>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="success"
                  className="cmnDelOkBtn"
                  onClick={reject}
                >
                  Yes
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        <Modal
          show={showurgtconfirmModal}
          onHide={ConfirmhandleClose}
          backdrop="static"
          keyboard={false}
          centered={true}
          className="modelalertbox"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.24)" }}
        >
          <Modal.Body>
            <div>
              <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                <b>{acceptActionLabel} Order?</b>
              </h6>
            </div>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="danger"
                  className="cmnDelCnclBtn"
                  onClick={ConfirmhandleClose}
                >
                  No
                </Button>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="success"
                  className="cmnDelOkBtn"
                  onClick={Submit}
                >
                  Yes
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showpaymntconfirmModal}
          onHide={this.closepaymntconfirmModal}
          backdrop="static"
          keyboard={false}
          centered={true}
          className="modelalertbox"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.24)" }}
        >
          <Modal.Body>
            <div>
              <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                <b>Order Paid?</b>
              </h6>
            </div>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="danger"
                  className="cmnDelCnclBtn"
                  onClick={this.closepaymntconfirmModal}
                >
                  No
                </Button>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="success"
                  className="cmnDelOkBtn"
                  onClick={this.statusisPaid}
                >
                  Yes
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.shwGetOrderConfirmModal}
          onHide={this.closeGetOrderConfirmModal}
          backdrop="static"
          keyboard={false}
          centered={true}
          className="modelalertbox"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.24)" }}
        >
          <Modal.Body>
            <div>
              <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                <b>Has the chemist received the order?</b>
              </h6>
            </div>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="danger"
                  className="cmnDelCnclBtn"
                  onClick={this.closeGetOrderConfirmModal}
                >
                  No
                </Button>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="success"
                  className="cmnDelOkBtn"
                  onClick={this.handleGetOrder}
                >
                  Yes
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default OrdersView;
